import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildNativeIntegrationAccountGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const getAllNativeIntegrationAccounts = buildNativeIntegrationAccountGetterObject('getAllNativeIntegrationAccounts');
export const getNativeIntegrationAccount = buildNativeIntegrationAccountGetterObject('getNativeIntegrationAccount');
export const getNativeIntegrationAccountForService = buildNativeIntegrationAccountGetterObject('getNativeIntegrationAccountForService');

const getters = {
	[getAllNativeIntegrationAccounts.getter]: (state) => state.data,
	[getNativeIntegrationAccount.getter]: (state, getters) => (nativeIntegrationAccountId) =>
		getters[getAllNativeIntegrationAccounts.getter](nativeIntegrationAccountId),
	[getNativeIntegrationAccountForService.getter]: (state, getters) => (serviceId) =>
		Object.values(getters[getAllNativeIntegrationAccounts.getter]).find((nia) => nia.platform.service.id === serviceId),
};

export default getters;
